"use client";

import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";

import { POSTHOG_DEPLOYMENT } from "@/utils/posthog/constants";

export function CookiebotBridge() {
  const posthog = usePostHog();

  useEffect(() => {
    if (
      typeof window === "undefined" ||
      POSTHOG_DEPLOYMENT.isAutomaticCaptureEnabled
    ) {
      return;
    }

    const applyStatisticsConsent = () => {
      if (
        window.Cookiebot === undefined ||
        window.Cookiebot.consent === undefined
      ) {
        return;
      }

      const statisticsConsent = window.Cookiebot.consent.statistics;

      const hasOptedInCapturing = posthog.has_opted_in_capturing();
      const hasOptedOutCapturing = posthog.has_opted_out_capturing();

      if (statisticsConsent) {
        if (!hasOptedInCapturing) {
          posthog.opt_in_capturing();
        }
      } else {
        if (!hasOptedOutCapturing) {
          posthog.opt_out_capturing();
        }
      }
    };

    window.addEventListener("CookiebotOnConsentReady", applyStatisticsConsent);
    window.addEventListener("CookiebotOnLoad", applyStatisticsConsent);
    window.addEventListener("CookiebotOnAccept", applyStatisticsConsent);
    window.addEventListener("CookiebotOnDecline", applyStatisticsConsent);

    // Apply immediately if consent already available
    if (window.Cookiebot !== undefined) {
      applyStatisticsConsent();
    }

    return () => {
      window.removeEventListener(
        "CookiebotOnConsentReady",
        applyStatisticsConsent
      );
      window.removeEventListener("CookiebotOnLoad", applyStatisticsConsent);
      window.removeEventListener("CookiebotOnAccept", applyStatisticsConsent);
      window.removeEventListener("CookiebotOnDecline", applyStatisticsConsent);
    };
  }, [posthog]);

  return null;
}
